import $ from 'jquery'

import Block from '../../common.blocks/block'

export default class ShoppingcartPayment extends Block {
	static title = 'shoppingcart-payment'

	constructor($el) {
		super($el)

		this.button = this.$el.find('button[type="submit"]')
		this.agree = this.$el.find('input[name="agree"]')
		this.message = this.$el.find('.message')
		this.inputs = this.$el.find('input[name="method_id"]')

		this.inputs.each((index, el) => {
			$(el).on('change', () => {
				$(document).trigger('checkout:add-payment-info', {
					payment_type: $(el).data('paymentTitle'),
				})
			})
		})

		this.button.on('click', () => {
			if (this.agree.prop('checked') == false) {
				this.message.addClass('message--visible')
			} else {
				this.message.find('.message').removeClass('message--visible')
			}
		})

		this.$el.find('form').on('submit', (e) => {
			if (
				!$('.parcelshop__customerid-input').is(':disabled') &&
				$('.parcelshop__customerid-input').val().length < 1
			) {
				$('.parcelshop__customerid-message').addClass('message--visible')
				$('.add-shipping-info').get(0).scrollIntoView({ behavior: 'smooth' })
				e.preventDefault()
			} else {
				$(document).trigger('checkout:begin-checkout')
			}
		})
	}
}
